import { useGetMerchantAppProductsQuery } from "Api/Queries/Merchants/useGetMerchantAppProductsQuery";
import { useGetMerchantTerminalContractQuery } from "Api/Queries/Merchants/useGetMerchantTerminalContractQuery";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { TerminalContractForm } from "Components/Shared/Merchant/Products/TerminalContracts/TerminalContractForm";
import type { MerchantTerminalContractDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Components.Merchant.TerminalContracts;

type Props = {
  isOpen: boolean;
  merchantPublicID: string;
  terminalContractPublicID: string;
  onAfterSubmit: (isSuccess: boolean) => void;
  contract: MerchantTerminalContractDto | null;
};

export const EditContractDialogContent = ({
  isOpen,
  merchantPublicID,
  terminalContractPublicID,
  onAfterSubmit,
  contract,
}: Props) => {
  const { t } = useResource();
  const { data, isFetching } = useGetMerchantTerminalContractQuery(
    merchantPublicID,
    terminalContractPublicID,
    isOpen,
  );

  const {
    data: merchantProducts = [],
    isFetching: isMerchantProductsFetching,
  } = useGetMerchantAppProductsQuery(merchantPublicID);

  if (isFetching || isMerchantProductsFetching) {
    return <CenteredCircularProgress />;
  }

  //null contract means we're creating new one
  if (!data && contract !== null) {
    return <ErrorText>{t(COMPONENT_RESOURCES.LoadingError)}</ErrorText>;
  }

  return (
    <TerminalContractForm
      merchantPublicID={merchantPublicID}
      merchantProducts={merchantProducts}
      contract={data || {}}
      onAfterSubmit={onAfterSubmit}
    />
  );
};
